import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import { postApiFormData } from "../../helpers/AxiosInstance";
import Button from "../Reusable/Button";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import TextField from "../Reusable/TextField";

const SettingIrd = ({ data }) => {
  const {
    formState: { errors },
    setError,
    setValue,
    handleSubmit,
    control,
    clearErrors,
    register,
    getValues,
  } = useForm<any>({
    defaultValues: async () => {
      return {
       company_name: data?.company_name,
       company_pan: data?.company_pan,
       irn_api_username: data?.irn_api_username,
       irn_api_password: data?.irn_api_password,
       irn_server_url: data?.irn_server_url,
      };
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const handleChangeSetting = async (values: any, setError: any) => {
    setIsLoading(true);
    const url = `${APIS.COMPANY_PROFILE}update/`;
    const formData = new FormData();
    formData.append("default_sales_account", values?.default_sales_account);
    formData.append(
      "default_purchase_account",
      values?.default_purchase_account
    );
    formData.append("type", values?.type);
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 200) {
        toast.success("Update Successfully");
        queryClient.invalidateQueries({
          queryKey: ["company-profile"],
          refetchType: "active",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit((data) => handleChangeSetting(data, setError))}
        className={tw`px-4`}
      >
        <div className={tw`grid grid-cols-3 gap-x-4 gap-y-2`}>
          <TextField
            control={control}
            placeholder="Company Name"
            name="company_name"
            label="Company Name"
          />
          <TextField
            control={control}
            placeholder="Company Pan"
            name="company_pan"
            label="Company Pan"
          />
          <TextField
            control={control}
            placeholder="IRN Username"
            name="irn_api_username"
            label="IRN Username"
          />
          <TextField
            control={control}
            placeholder="IRN Password"
            name="irn_api_password"
            label="IRN Password"
          />
          <TextField
            control={control}
            placeholder="IRN   Url"
            name="irn_server_url"
            label="IRN Url"
          />

        </div>
        <div className={tw`w-full flex justify-end`}>
          <div className={tw`w-24`}>
            <Button label="Save" isLoading={isLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default SettingIrd;

